module.exports = __webpack_public_path__ + "static/devoxxuk-e43e2d51c648e5b1bfa500cea3aa51ac.png";